import { Component } from '@angular/core';

@Component({
    selector: 'sign-oidc',
    templateUrl: './sign-oidc.component.html',
    styleUrls: ['sign-oidc.component.scss'],
    standalone: false
})
export class SignOidcComponent {
}
